function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.28639 10.65V7.75H3.6012V26.6H22.3975V7.75H19.7123V10.65H6.28639ZM8.97157 4.85C8.97157 3.69631 9.39592 2.58987 10.1513 1.77409C10.9066 0.958302 11.9311 0.5 12.9993 0.5C14.0676 0.5 15.0921 0.958302 15.8474 1.77409C16.6028 2.58987 17.0271 3.69631 17.0271 4.85H22.3975C23.1097 4.85 23.7926 5.15553 24.2962 5.69939C24.7998 6.24325 25.0827 6.98087 25.0827 7.75V26.6C25.0827 27.3691 24.7998 28.1068 24.2962 28.6506C23.7926 29.1945 23.1097 29.5 22.3975 29.5H3.6012C2.88905 29.5 2.20606 29.1945 1.70249 28.6506C1.19892 28.1068 0.916016 27.3691 0.916016 26.6V7.75C0.916016 6.98087 1.19892 6.24325 1.70249 5.69939C2.20606 5.15553 2.88905 4.85 3.6012 4.85H8.97157ZM12.9993 3.4C12.6433 3.4 12.3018 3.55277 12.05 3.8247C11.7982 4.09662 11.6568 4.46544 11.6568 4.85C11.6568 5.23456 11.7982 5.60338 12.05 5.8753C12.3018 6.14723 12.6433 6.3 12.9993 6.3C13.3554 6.3 13.6969 6.14723 13.9487 5.8753C14.2005 5.60338 14.3419 5.23456 14.3419 4.85C14.3419 4.46544 14.2005 4.09662 13.9487 3.8247C13.6969 3.55277 13.3554 3.4 12.9993 3.4Z",
  fill: "white"
});

var SvgSurvey = function SvgSurvey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurvey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/survey.40612135.svg";
export { ForwardRef as ReactComponent };